/**
 * Console Error Dump Utility
 *
 * Provides console commands to access error logs
 * Usage: In browser console, type: window.dumpErrors()
 */

import { ErrorLogViewer } from './errorLogViewer';

// Make error dump available globally
if (typeof window !== 'undefined') {
  (window as any).dumpErrors = () => {
    const errors = ErrorLogViewer.getAllErrors();
    const summary = ErrorLogViewer.getErrorSummary();

    // eslint-disable-next-line no-console
    console.group('🔴 Error Logs Summary');
    // eslint-disable-next-line no-console
    console.log(`Total Errors: ${summary.total}`);
    // eslint-disable-next-line no-console
    console.log(`Recent (1h): ${summary.recent}`);
    // eslint-disable-next-line no-console
    console.log(`Errors: ${summary.byLevel.error || 0}`);
    // eslint-disable-next-line no-console
    console.log(`Warnings: ${summary.byLevel.warning || 0}`);
    // eslint-disable-next-line no-console
    console.groupEnd();

    // eslint-disable-next-line no-console
    console.group('📋 All Error Logs');
    if (errors.length === 0) {
      // eslint-disable-next-line no-console
      console.log('No errors logged');
    } else {
      errors.forEach((error, index) => {
        // eslint-disable-next-line no-console
        console.group(`Error #${index + 1} - ${error.level || 'error'}`);
        // eslint-disable-next-line no-console
        console.log('Message:', error.message);
        // eslint-disable-next-line no-console
        console.log('Timestamp:', error.timestamp);
        // eslint-disable-next-line no-console
        console.log('Source:', error.source);
        if (error.stack) {
          // eslint-disable-next-line no-console
          console.log('Stack:', error.stack);
        }
        if (error.context && Object.keys(error.context).length > 0) {
          // eslint-disable-next-line no-console
          console.log('Context:', error.context);
        }
        // eslint-disable-next-line no-console
        console.groupEnd();
      });
    }
    // eslint-disable-next-line no-console
    console.groupEnd();

    return errors;
  };

  (window as any).exportErrors = () => {
    const json = ErrorLogViewer.exportErrors();
    // eslint-disable-next-line no-console
    console.log('Error logs JSON:');
    // eslint-disable-next-line no-console
    console.log(json);
    return json;
  };

  (window as any).clearErrors = () => {
    ErrorLogViewer.clearAllErrors();
    // eslint-disable-next-line no-console
    console.log('✅ All error logs cleared');
  };

  (window as any).getErrorSummary = () => {
    const summary = ErrorLogViewer.getErrorSummary();
    // eslint-disable-next-line no-console
    console.table(summary);
    return summary;
  };

  (window as any).openErrorLogs = () => {
    // Try to access the app's setActiveSection function
    // This will work if the app exposes it globally or we can use localStorage
    localStorage.setItem('cyclone_active_section', 'error-logs');
    window.location.reload();
  };

  // eslint-disable-next-line no-console
  console.log(
    '%c🔧 Error Log Utilities Available',
    'color: #4CAF50; font-weight: bold; font-size: 14px;'
  );
  // eslint-disable-next-line no-console
  console.log('%cCommands:', 'color: #2196F3; font-weight: bold;');
  // eslint-disable-next-line no-console
  console.log('  - window.dumpErrors() - View all error logs in console');
  // eslint-disable-next-line no-console
  console.log('  - window.exportErrors() - Export errors as JSON');
  // eslint-disable-next-line no-console
  console.log('  - window.clearErrors() - Clear all error logs');
  // eslint-disable-next-line no-console
  console.log('  - window.getErrorSummary() - Get error statistics');
  // eslint-disable-next-line no-console
  console.log('  - window.openErrorLogs() - Open error logs viewer in app');
}
